import { DepartmentViewModel } from '../../../../entities/Departments/Departments'

export default function removeDepartmentsWithGroupIdFromList(
    departments: DepartmentViewModel[],
    groupId: string | number,
): DepartmentViewModel[] {
    return departments.filter(department => ! department.group || (department.group && department.group.id !== groupId))
}
